// extracted by mini-css-extract-plugin
module.exports = {"container":"LimitActionTokenHeader_container__1IRfg","token_info":"LimitActionTokenHeader_token_info__3LsFK"};